export const selectSubCompany = ({ subCompany }) => subCompany;
